<template>
    <va-edit-layout>
        <SAFETReimbursementEventItemCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></SAFETReimbursementEventItemCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
